// extracted by mini-css-extract-plugin
module.exports = {"main-component":"background_main-component__13X4J"};